import { render } from "./CrmDealKanbanBoardDeals.vue?vue&type=template&id=508e950f&scoped=true"
import script from "./CrmDealKanbanBoardDeals.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanBoardDeals.vue?vue&type=script&lang=js"

import "./CrmDealKanbanBoardDeals.vue?vue&type=style&index=0&id=508e950f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508e950f"]])

export default __exports__